import { CircleAlert, CircleCheck, CircleDashed } from 'lucide-react';
import type { JSX } from 'react';
import { classNames } from '../utils/class-names.ts';

export const StatusTone = ['success', 'warning', 'danger', 'neutral'] as const;
export type StatusTone = (typeof StatusTone)[number];

export interface StatusBadgeProps {
  children: string;
  tone?: StatusTone;
}

const TONE_ICON = {
  success: CircleCheck,
  warning: CircleAlert,
  danger: CircleAlert,
  neutral: CircleDashed,
} as const satisfies Record<StatusTone, typeof CircleCheck>;

function StatusToneIcon({ tone }: { readonly tone: StatusTone }): JSX.Element {
  const Icon = TONE_ICON[tone];
  return <Icon aria-hidden="true" size={14} strokeWidth={2} />;
}

export function StatusBadge({ children, tone = 'neutral' }: StatusBadgeProps): JSX.Element {
  return (
    <span className={classNames('fui-status-badge', `fui-status-badge-${tone}`)}>
      <StatusToneIcon tone={tone} />
      {children}
    </span>
  );
}
